let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8059b"), load("2IX0x")]).then(() => parcelRequire('jF1MT'));